  setTimeout(async () => {
    try {
      const PhotoSwipe = (await import('https://cdn.shopify.com/s/files/1/2314/6641/files/photoswipe.js?v=1752704460')).default;
      // Select images from the main carousel
      const images = document.querySelectorAll('.buy-menu-slider .glide__slides img');

      // Track drag state
      let isDragging = false;
      let startX, startY;

      images.forEach((image) => {
        image.addEventListener('mousedown', (e) => {
          isDragging = false;
          startX = e.pageX;
          startY = e.pageY;
        });

        image.addEventListener('mousemove', (e) => {
          if (startX && startY) {
            const moveX = Math.abs(e.pageX - startX);
            const moveY = Math.abs(e.pageY - startY);
            if (moveX > 5 || moveY > 5) {
              isDragging = true;
            }
          }
        });

        image.addEventListener('click', (e) => {
          e.preventDefault();

          if (isDragging) {
            return;
          }

          // Get all images from the same carousel as the clicked image
          const carousel = image.closest('.glide__slides');
          const carouselImages = Array.from(carousel.querySelectorAll('img'));

          // Get the correct index of the clicked image
          const clickedIndex = carouselImages.indexOf(image);

          const dataSource = carouselImages.map(img => ({
            src: img.src,
            width: parseInt(img.naturalWidth) || 1200,
            height: parseInt(img.naturalHeight) || 800,
            alt: img.alt || 'Product image'
          }));

          const options = {
            dataSource,
            index: clickedIndex,
            pswpElement: document.querySelector('.pswp'),
            showHideAnimationType: 'fade',
            bgOpacity: 0.85,
            arrowEl: true,
            padding: { top: 30, bottom: 30, left: 30, right: 30 },
            closeOnVerticalDrag: true,
            wheelToZoom: false,
            arrowPrev: true,
            arrowNext: true
          };

          const pswp = new PhotoSwipe(options);

          pswp.on('uiRegister', () => {
            pswp.ui.registerElement({
              name: 'button-close',
              order: 9,
              isButton: true,
              html: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5L5 15M5 5l10 10"/></svg>',
              onClick: () => {
                pswp.close();
              }
            });

            pswp.ui.registerElement({
              name: 'arrow-prev',
              order: 10,
              isButton: true,
              html: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5 absolute top-1 left-0.5"><path d="M15 18l-6-6 6-6"/></svg>',
              onClick: () => {
                pswp.prev();
              }
            });

            pswp.ui.registerElement({
              name: 'arrow-next',
              order: 11,
              isButton: true,
              html: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5 absolute top-1 left-1"><path d="M9 18l6-6-6-6"/></svg>',
              onClick: () => {
                pswp.next();
              }
            });
          });

          pswp.init();
        });

        image.addEventListener('mouseup', () => {
          startX = startY = null;
        });

        image.style.cursor = 'pointer';
      });
    } catch (error) {
      console.error('Error initializing PhotoSwipe:', error);
    }
  }, 4000);
